// Content sourced from Google Play listing + design_guidelines.json + user-uploaded assets
export const STORE_URL =
  "https://play.google.com/store/apps/details?id=com.VoltGames.Sniper";

export const DISCORD_URL = "https://discord.gg/NRsD9p4EVr";

// User-uploaded brand & marketing assets
export const ASSETS = {
  // High-res game logo (white, mountains+sniper hunter)
  gameLogo:
    "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/co40c5qr_Camada%207.png",
  // Square app icon (used in header + footer + favicon)
  appIcon:
    "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/phkebguf_sniper_hunter_appicon.png",
  googlePlayBadge:
    "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/ndyb45gq_Google_Play_Store_badge_EN.svg.webp",
  splashBanner:
    "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/hyc5xhcb_banner_chests_podium.png",
  // Cinematic camp-by-the-lake image for the footer CTA
  ctaBanner:
    "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/xl1bzn5l_banner.png",
};

// Trophy animal renders (transparent black bg — drop onto dark cards)
export const TROPHY_ANIMALS = [
  {
    key: "cougar",
    name: "Mountain Cougar",
    biome: "High Ridges, USA",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/ek9a3ao5_cougar.png",
  },
  {
    key: "rhino",
    name: "White Rhinoceros",
    biome: "Sub-Saharan Bush",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/f1vyo36d_rhinoceros.png",
  },
  {
    key: "moose",
    name: "Northern Moose",
    biome: "Boreal Forest",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/t3g10m46_moose.png",
  },
];

// Premium weapon renders
export const PREMIUM_GUNS = [
  {
    key: "awm",
    name: "AWM · Royal Blue",
    rarity: "Epic",
    rarityHex: "#a78bfa",
    blurb:
      "Hand-glazed bolt-action with cobalt filigree. +18% scope steadiness and a one-shot guarantee on big game.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/fwmgckx8_AWM_legendary.png",
  },
  {
    key: "remington",
    name: "Remington 700 · Phantom",
    rarity: "Rare",
    rarityHex: "#60a5fa",
    blurb:
      "Lightweight precision rifle. Built for snap-shots in dense forest and lake-side ambushes.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/w4ll2dam_Remington_epic.png",
  },
  {
    key: "m107",
    name: "M107 · Inferno",
    rarity: "Rare",
    rarityHex: "#60a5fa",
    blurb:
      "Anti-material heavyweight wrapped in molten flame finish. Heavy recoil, devastating stopping power.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/pr5mbsbo_M82_epic.png",
  },
];

// Signature ammunition
export const SIGNATURE_BULLETS = [
  {
    key: "phantom",
    name: "Phantom",
    tag: "Spectral",
    accentHex: "#34d399",
    blurb: "Emerald skull tracer that haunts even the toughest targets.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/bsfskl2q_phatom.png",
  },
  {
    key: "inferno",
    name: "Inferno",
    tag: "Incendiary",
    accentHex: "#f97316",
    blurb: "Dragon-etched fire round. Flat trajectory, scorched-earth impact.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/uyfvdmva_infernov02.png",
  },
  {
    key: "leviathan",
    name: "Leviathan",
    tag: "Deep Cold",
    accentHex: "#22d3ee",
    blurb: "Ocean-relief slug carved with sea-dragon glyphs. Brutal at range.",
    image:
      "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/xb1b5sk1_leviathan.png",
  },
];

// 4 official store screenshots + short captions
export const STORE_SCREENSHOTS = [
  {
    src: "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/djr9vdud_unnamed.webp",
    title: "The Hunt Is On",
    caption:
      "Track deer, wolves, bears and lions across breathtaking 3D habitats — every animal reacts to your every move.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/8ez4ge7k_Screenshots_phone_04.jpg",
    title: "1st & 3rd Person",
    caption:
      "Swap perspectives on the fly — down-the-scope precision or tactical third-person awareness, whichever fits the shot.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/utixk3kj_Screenshots_phone_03%20%282%29.jpg",
    title: "Unlock & Upgrade",
    caption:
      "Collect 30+ rifles across Common, Rare and Epic tiers. Tune damage, penetration, velocity and magnification.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_marksman-portal-3/artifacts/4k4igmf5_Screenshots_phone_02%20%282%29.jpg",
    title: "Diverse Wildlife",
    caption:
      "From elephant to cougar, moose to black panther — pursue a roster of species across forests, plains and tundra.",
  },
];

export const GAME = {
  name: "Sniper Hunter",
  fullName: "Sniper Hunter: 3D Hunting Game",
  tagline: "The Premium Hunting Experience",
  developer: "Volt Games",
  rating: 4.4,
  reviews: 60,
  downloads: "10K+",
  ageRating: "Teen",
  category: "Sports",
  updated: "May 7, 2026",
  supportEmail: "info@voltgames.io",
  privacyUrl: "https://www.voltgames.io/privacy_policy",
  description:
    "Pick your gun, select your custom bullets, and step into the boots of a master Hunter. Venture deep into dense forests, scale towering mountains, and stake out serene lakes to hunt the wildest animals on the planet.",
  icon:
    "https://play-lh.googleusercontent.com/MJrcBKHW5N-DpfZ6LFLk8zGd_MZVSVxY4XzkdZfbQr2M-OfeKrVNydPC0PEl68FIZWH-=w240-h480-rw",
};

export const SCREENSHOTS = [
  "https://play-lh.googleusercontent.com/X2hnGtkTZR1ibsjeXsyx06kvalSDww4mH_R7NJlCaLLFp2vo7WBrFvtWmB7Iiq7atWyOdrYy2z-rT_OypB3h=w526-h296-rw",
  "https://play-lh.googleusercontent.com/yuE4Y5PZdVZhCL8a-ikhMDqxPVOP-LU2Z_m3ddhWzHcuLeXWVNg2oWLovUJabp0H7KbuuQF3vL7TKBjDzWEGnNU=w526-h296-rw",
  "https://play-lh.googleusercontent.com/TFAuhrrpnQpZvkjSXnhmTEhQbqnvQKJ_oNgjM6WqzPDL7hNqKSWCj2oa-WgChaq_dc7fEx9axvJqZ9texhYZMA=w526-h296-rw",
  "https://play-lh.googleusercontent.com/6PzS8F1-CE26z2JJOsTVHig3f7RHmqCIRcQvYG9VIiFNYs6Lv_BHolyiD_HciYEr3LNvuNgM9gg5pw1MWyJX=w526-h296-rw",
  "https://play-lh.googleusercontent.com/2yO3537T39IinUj6XYzXxXRTLxizZiXQyRYOsb57_WUaYUwDRTf_NUo41y_0mL6ODvqq_kT_asnMBd9t0pVxyOo=w526-h296-rw",
  "https://play-lh.googleusercontent.com/e51hSo8VgzVULD71ySuR6E_t61BMzFWf46LOCfdrilrAv2w8xZKodPMvCfXVrIXlfoc5nkRzJYCaDaRP9YQJS7c=w526-h296-rw",
  "https://play-lh.googleusercontent.com/k8JYb-4ECvoWHjVpbJXemB8TU28KraXA1O7ANOK30v9ULwnlWVOaAUe-pcN5T_LYR3nYxxgilCS-WFSo9xOm=w526-h296-rw",
  "https://play-lh.googleusercontent.com/RvrnCW6D1zUphvWqYV5mVTz8EiufQWkv6gvN-PSlj27l690GV9tMfI9QDzzg27QZ11I6oB27WJvs_mIQ9ogmpw=w526-h296-rw",
  "https://play-lh.googleusercontent.com/GJTe_cp5oVoObOL7uQv2DTTO1Kq0LS4OMbF85Cd-qATz2EmdDaNmhFjgLC-sD88l3UiqwcO5kPU1989updnN_AI=w526-h296-rw",
  "https://play-lh.googleusercontent.com/ogprrecI00RW1m-4kLnvZxk--oOw7ZlRs97LwHqvJ0z_eX_20LcP2aJC4L6C26IPx-IcDXrzoDyreOyQzxee=w526-h296-rw",
];

export const WEAPONS = [
  {
    name: "Savage 110",
    type: "Classic Bolt-Action",
    caliber: ".308 Win",
    role: "Reliable mid-range workhorse — ideal for first-time hunters.",
    screenshot: SCREENSHOTS[2],
  },
  {
    name: "Springfield M1A",
    type: "Semi-Auto Tactical",
    caliber: "7.62×51",
    role: "Punchy follow-up shots when the herd starts running.",
    screenshot: SCREENSHOTS[5],
  },
  {
    name: "Remington 700",
    type: "Precision Bolt-Action",
    caliber: ".300 Win Mag",
    role: "Long-range trophy specialist — pair with Void rounds.",
    screenshot: SCREENSHOTS[6],
  },
  {
    name: "Barrett M82",
    type: "Anti-Material",
    caliber: ".50 BMG",
    role: "Endgame heavyweight unlocked at high hunter tiers.",
    screenshot: SCREENSHOTS[8],
  },
];

export const ANIMALS = [
  {
    name: "Bull Elk",
    biome: "Rocky Mountains, USA",
    difficulty: "Intermediate",
    image:
      "https://images.unsplash.com/photo-1638595325231-b320fa288ebc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxtYWplc3RpYyUyMGVsayUyMHN1bnNldHxlbnwwfHx8fDE3Nzg1MTMwMjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Grizzly Bear",
    biome: "Alaskan Wilderness",
    difficulty: "Apex",
    image:
      "https://images.unsplash.com/photo-1677538807210-ae14cc23d416?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxncml6emx5JTIwYmVhciUyMHdpbGR8ZW58MHx8fHwxNzc4NTEzMDMyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Savanna Lion",
    biome: "African Plains",
    difficulty: "Expert",
    image:
      "https://images.unsplash.com/photo-1686672605288-f83df6f815f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx3aWxkJTIwbGlvbiUyMHBvcnRyYWl0JTIwZGFya3xlbnwwfHx8fDE3Nzg1MTMwMzJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Timber Wolf",
    biome: "Boreal Forest",
    difficulty: "Advanced",
    image:
      "https://images.unsplash.com/photo-1564166174574-a9666f590437?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx3aWxkJTIwd29sZnxlbnwwfHx8fDE3Nzg1MTMwMzZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const FOREST_MIST =
  "https://images.unsplash.com/photo-1688541197263-7b1af0e920fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwcGluZSUyMGZvcmVzdCUyMG1pc3R8ZW58MHx8fHwxNzc4NTEzMDM2fDA&ixlib=rb-4.1.0&q=85";

export const GUIDE_CARDS = [
  {
    key: "arsenal",
    title: "The Arsenal",
    icon: "Crosshair",
    summary:
      "Build a meticulous collection of high-fidelity rifles — from the trusty Savage 110 to the semi-auto Springfield M1A.",
    bullets: [
      "Bolt-action, semi-auto & anti-material classes",
      "Real ballistic feel, scope drift & wind drop",
      "Upgrade slots: barrel, optics, stock, trigger",
    ],
  },
  {
    key: "ammo",
    title: "Custom Ammunition",
    icon: "Flame",
    summary:
      "Pair legendary weapons with tier-style bullets that change how every shot reads on the scope.",
    bullets: [
      "Inferno Tracers — incendiary spread for soft targets",
      "Relic Rounds — historic stopping power, slower flight",
      "Void Bullets — cosmic-glow projectiles, flat trajectory",
    ],
  },
  {
    key: "progression",
    title: "Hunter Progression",
    icon: "TrendingUp",
    summary:
      "Master five vectors that compound across every season — your stats follow you into PvP.",
    bullets: [
      "Marksmanship · Stealth · Stamina · Tracking · Trophy",
      "Unlock new biomes & weapon tiers per rank",
      "Weekend Challenges and Wild Race ranked drops",
    ],
  },
  {
    key: "tours",
    title: "Global Tours",
    icon: "MapPin",
    summary:
      "Travel from grassy clearings to safari outskirts — each habitat reacts naturally to your presence.",
    bullets: [
      "USA · Africa · Alpine ranges · Boreal forests",
      "Day/night cycle with realistic wind systems",
      "First-person scope or third-person tactical view",
    ],
  },
];

export const EVENTS = [
  { title: "Weekend Challenge", desc: "Exclusive limited-time missions, global leaderboards." },
  { title: "Wild Race", desc: "First to 5 hunting victories takes the season banner." },
  { title: "Animal Collection", desc: "Hunt the roster across maps to unlock rare gear." },
  { title: "Sure Shot", desc: "Standardized bullet — pure aim, no gear advantage." },
];
